export const formatParams = params => {
  const paramKeys = Object.keys(params);
  if (paramKeys.length === 0) return '';
  const urlParams = new URLSearchParams();
  paramKeys.map(key => urlParams.append(key, params[key]));
  return `?${urlParams.toString()}`;
};
